"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TextAreaField = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Primitives_1 = require("../Primitives");
var TextAreaField_module_scss_1 = __importDefault(require("./TextAreaField.module.scss"));
/**
 * {@link https://cultureamp.design/components/text-area-field/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-form-text-area-field--default-story Storybook}
 */
var TextAreaField = function (_a) {
    var labelText = _a.labelText, _b = _a.inline, inline = _b === void 0 ? false : _b, validationMessage = _a.validationMessage, description = _a.description, _c = _a.variant, variant = _c === void 0 ? "default" : _c, id = _a.id, _d = _a.reversed, reversed = _d === void 0 ? false : _d, _e = _a.status, status = _e === void 0 ? "default" : _e, disabled = _a.disabled, restProps = __rest(_a, ["labelText", "inline", "validationMessage", "description", "variant", "id", "reversed", "status", "disabled"]);
    var validationMessageAria = validationMessage
        ? "".concat(id, "-field-validation-message")
        : "";
    var descriptionAria = description ? "".concat(id, "-field-message") : "";
    var ariaDescribedBy = [validationMessageAria, descriptionAria].reduce(function (prev, curr) { return (curr ? [curr, prev].join(" ") : prev); }, "");
    var renderDescriptionOnTop = variant === "prominent";
    var renderDescription = function (position) {
        if (!description)
            return null;
        return (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(TextAreaField_module_scss_1["default"].message, disabled && TextAreaField_module_scss_1["default"].disabled) },
            react_1["default"].createElement(Primitives_1.FieldMessage, { id: descriptionAria, automationId: "".concat(id, "-field-description"), message: description, reversed: reversed, position: position })));
    };
    return (react_1["default"].createElement(Primitives_1.FieldGroup, { id: "".concat(id, "-field-group"), inline: inline, automationId: "".concat(id, "-field-group"), classNameOverride: disabled ? TextAreaField_module_scss_1["default"].disabled : undefined },
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(TextAreaField_module_scss_1["default"].textareaLabel, variant === "prominent" && TextAreaField_module_scss_1["default"].textareaLabelProminent) },
            react_1["default"].createElement(Primitives_1.Label, { id: "".concat(id, "-field-label"), automationId: "".concat(id, "-field-label"), htmlFor: "".concat(id, "-field-textarea"), labelText: labelText, reversed: reversed, variant: variant, disabled: disabled })),
        renderDescriptionOnTop && renderDescription("top"),
        react_1["default"].createElement(Primitives_1.TextArea, __assign({ id: "".concat(id, "-field-textarea"), automationId: "".concat(id, "-field-textarea"), reversed: reversed, status: status, disabled: disabled, "aria-describedby": ariaDescribedBy }, restProps)),
        !disabled && validationMessage && (react_1["default"].createElement(Primitives_1.FieldMessage, { id: validationMessageAria, automationId: validationMessageAria, message: validationMessage, status: status, reversed: reversed })),
        !renderDescriptionOnTop && renderDescription("bottom")));
};
exports.TextAreaField = TextAreaField;
//# sourceMappingURL=TextAreaField.js.map